module.exports = require('./basic').extend({
    modelClass: null,
    query: null,
    sortProperty: null,
    sortDirection: 'ASC',

    parser: function(data) {
        return data
    },

    setQ: function(q, instant, force) {
        if (q === this.get('q')) {
            return;
        }
        if (!force && !this.get('field.selector')) {
            return;
        }
        this.set('q', q);
        this.set('isLoading', true);
        if (instant || BD.store.allOfTypeIsLoaded(this.get('modelClass'))) {
            this.updateContent();
        } else {
            Em.run.debounce(this, this.updateContent, 500)
        }
    },
    updateContent: function() {
        var self = this;
        var parser = this.get('parser').bind(this)
        var content = this.get('modelClass').filter({
            q: this.get('q'),
            query: _.extend({}, this.get('query'), this.get('field.query')),
            sortProperty: this.get('sortProperty'),
            sortDirection: this.get('sortDirection')
        });
        var oldContent = self.get('content');
        if (!oldContent || !oldContent.get('isLoaded')) {
            if (oldContent) {
                oldContent.destroy();
            }
            self.set('content', parser(content));
        }
        content.promise.then(function() {
            //TODO: What happens if two requests are running simultaneously? The first one should probably be aborted
            self.set('isLoading', false);
            self.trigger('didLoad');
            var oldContent = self.get('content');
            if (content !== oldContent) {
                if (oldContent) {
                    oldContent.destroy();
                }
                self.set('content', parser(content));
            }
            var selector = self.get('field.selector');
            if (selector) {
                selector.highlightOptionByIndex(0);
            }
        });
    },
    resetContent: function() {
        var content = this.get('content');
        if (content) {
            this.set('q', null);
            this.set('content', null);
            content.destroy();
        }
    },

    fieldQueryDidChange: function() {
        this.resetContent()
    }.observes('field.query'),

    isLoaded: Em.computed.alias('content.isLoaded'),

    willDestroy: function() {
        this._super();
        this.resetContent();
    }
});
